/**
 * Iter XX.291 — Legacy `/second-innings/session-1` alias.
 *
 * Preserved as a backwards-compatible redirect so every already-sent
 * personalized link (`?rid=&t=`) keeps landing on a working booking
 * page. Immediately forwards to the canonical multi-session page.
 *
 * DO NOT rebuild the reservation UI here — see `SecondInningsBook.jsx`.
 */
import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function SecondInningsSession1() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const rid = params.get("rid") || "";
    const t   = params.get("t")   || "";
    const qs  = new URLSearchParams();
    if (rid) qs.set("rid", rid);
    if (t)   qs.set("t", t);
    const target = qs.toString()
      ? `/second-innings/book?${qs.toString()}`
      : "/second-innings/book";
    navigate(target, { replace: true });
  }, [params, navigate]);

  return (
    <main
      className="min-h-screen bg-neutral-950 text-neutral-100"
      data-testid="si-session1-redirect"
    >
      <div className="max-w-xl mx-auto px-4 sm:px-6 pt-10 pb-24">
        <p className="text-neutral-400">Loading…</p>
      </div>
    </main>
  );
}
